<!--zx_rts_db.t_rt_cars（车辆表）-dialog-->
<template>
  <el-dialog :title="showTitle" :visible.sync="showFlag">
    <el-form
      :inline="true"
      :model="formData"
      class="demo-ruleForm"
      label-width="100px"
      :rules="formRules"
      ref="formData"
      :size="GLOBAL.config.systemSize"
      element-loading-text="数据处理中...请稍等..."
      v-loading="loading">

      <!--区域-->
      <el-form-item label="区域：" prop="name" style="margin-top: 20px" v-if="addCarInfo">
        <cascader :set-props="setProps"
                  :set-size="GLOBAL.config.systemSize" maxlength="64"
                  ref="myArea">
        </cascader>
      </el-form-item>
      <!--车牌号码-->
      <el-form-item label="车牌号码：" prop="name" style="margin-top: 20px" v-if="addCarInfo">
        <el-input v-model="formData.carNumber" placeholder="车牌号码" maxlength="64"></el-input>
      </el-form-item>



      <!--车牌号码-->
      <el-form-item label="人员姓名：" prop="name" style="margin-top: 20px">
        <el-input v-model="formData.name" placeholder="人员姓名" maxlength="64"></el-input>
      </el-form-item>
      <el-form-item label="手机号：" prop="phNumber" style="margin-top: 20px">
        <el-input v-model="formData.phoneNumber" placeholder="手机号" maxlength="64"></el-input>
      </el-form-item>
      <el-form-item label="状态：" prop="chenge" style="margin-top: 20px">
        <el-select v-model="formData.state" placeholder="请选择" style="width: 100%">
          <el-option
            v-for="item in isState"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>



    </el-form>
    <el-row class="margin-top-20">
      <el-button @click="closeDialog" style="margin: 0 20px;" :size="GLOBAL.config.systemSize">关闭</el-button>
      <el-button v-if="editableFlag" type="primary" @click="saveOrUpdateForm" style="margin: 0 20px;"
                 :size="GLOBAL.config.systemSize">保存
      </el-button>
    </el-row>
  </el-dialog>
</template>
<script>
  import cascader from '../../../components/Cascader'

  export default {
    name: 'cars',
    props: {
      id: {
        type: String
      },
      refresh: {
        type: Function
      },
      closeSelf: {
        type: Function
      }
    },
    data() {
      return {
        addCarInfo: false,
        isState: [{
          value: '选项1',
          label: '在职'
        },{
          value: '选项2',
          label: '离职'
        }],
        formData: {
          id: '',
          villageCode: '',
          carNo: '',
          listManageArea: []
        },
        // 校验规则
        formRules: {
          villageCode: [],
          carNo: [],
        },
        //管理区域
        setManageProps: {
          multiple: true, // 多选
          checkStrictly: true, // 父节点取消选中关联
          value: 'code',
          label: 'name',
          children: 'children',
          leaf: 'leaf'
        },
        //所属区域
        setProps: {
          multiple: false, // 单选
          checkStrictly: true, // 父节点取消选中关联
          value: 'code',
          label: 'name',
          children: 'children',
          leaf: 'leaf'
        },
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        // 字典数据
        dictionary: {},
        editableFlag: true,
        loading: false,
        showTitle: '新增',
        showFlag: false
      }
    },
    components: {
      cascader
    },
    methods:
      {
        open: function (type, rowData) {
          let _this = this
          let _title = ''
          if (type === 'add') {
            _title = '驾驶员新建编辑'
          } else if (type === 'edit') {
            _title = '驾驶员编辑'
          } else if (type === 'addCarInfo') {
            _title = '抽粪车辆新建编辑'
            _this.addCarInfo = true
          }
          _this.showTitle = _title
          _this.showFlag = true
          if (rowData) {
            _this.formData = rowData

            // 调用级联组建内 init 方法重组默认值
            setTimeout(function () {
              _this.$refs.myArea.init(_this.formData.villageCode)
            }, 100)
          }
        },
        getTreeData: function () {
          // let _this = this
          // // 3、 调接口获取数据
          // _this.FUNCTIONS.systemFunction.interactiveData(
          //   _this,
          //   _this.GLOBAL.config.businessFlag.zxOrganization,
          //   _this.GLOBAL.config.handleType.getTree,
          //   null,
          //   null,
          //   resultData => {
          //     _this.loading = false
          //     if (resultData) {
          //       _this.treeData = resultData
          //     } else {
          //       _this.$message.warning('获取组织数据失败～')
          //     }
          //   },
          //   () => {
          //     _this.loading = false
          //   }
          // )
        },
        getInfo: function () {
          // this.getTreeData()
        },
        closeDialog: function () {
          this.showFlag = false
        },
        saveOrUpdateForm: function () {
          // // 参数处理======start==========
          // let myAreaCode = this.$refs.myArea.sendToParent('value')
          // if (!myAreaCode) {
          //   this.$message.warning('请勾选区域～')
          //   return
          // }
          //
          // let checkedNode = this.$refs.manageArea.sendToParent('obj')
          // if (!checkedNode) {
          //   _this.$message.warning('请勾选区域～')
          //   return
          // }
          // let checkedAreaId = []
          // checkedNode.forEach(item => {
          //   checkedAreaId.push({"orgCode": item.code, "orgId": item.id})
          // })
          // this.formData.villageCode = myAreaCode
          // this.formData.listManageArea = checkedAreaId
          // // 参数处理======end============
          // let _this = this
          // _this.loading = true
          // let params = this.formData
          // _this.FUNCTIONS.systemFunction.interactiveData(
          //   _this,
          //   _this.GLOBAL.config.businessFlag.rtCar,
          //   _this.GLOBAL.config.handleType.add,
          //   _this.FUNCTIONS.systemFunction.removeNullFields(params),
          //   null,
          //   resultData => {
          //     _this.loading = false
          //     if (resultData) {
          //       _this.$message.success('保存成功～')
          //       _this.showFlag = false
          //       _this.$props.refresh && this.$props.refresh('init')
          //     } else {
          //       _this.$message.warning('保存失败～')
          //     }
          //   },
          //   () => {
          //     _this.loading = false
          //   })
        }
      }
  }
</script>



// WEBPACK FOOTER //
// src/view/system/car/CarEditor.vue